import gql from 'graphql-tag';

export const BULK_MEMBER_APPLICANT_OPERATION_MUTATION = gql`
  mutation BulkMemberApplicantOperationMutation($projectId: Int!, $operation: MemberApplicantOperation!, $clientId: String, $memberIds: [Int!], $query: JSONObject) {
    success: bulkMemberApplicantOperation(projectId: $projectId, operation: $operation, memberIds: $memberIds, clientId: $clientId, query: $query)
  }
`;
